import { render, staticRenderFns } from "./FilterExpiryDate.vue?vue&type=template&id=1c2fdf2a&lang=pug&"
import script from "./FilterExpiryDate.vue?vue&type=script&lang=js&"
export * from "./FilterExpiryDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports